<template>
  <div class="layout-container layout-column">
    <div class="section-cta-mansory-block">
      <h2 class="heading-h2 font--CabritoFlare">Plan your trip</h2>
      <slot></slot>
    </div>
  </div>
</template>